import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

const MyPdfFullViewer = ({ pdfFile }) => {
  const toolbarPluginInstance = toolbarPlugin();

  return (
    <div style={{ height: "auto" }}>
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js`}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Viewer fileUrl={pdfFile} plugins={[toolbarPluginInstance]} />
        </div>
      </Worker>
    </div>
  );
};

export default MyPdfFullViewer;
